<template>
  <container title='平台运营数据统计' :loading='loading' :nodata='nodata' style='width: 42.3529%;height: 388px;'>
    <div class="operationDataStatistics fix-box-align-center">
      <gauge :value='premiumRate'/>
      <div class="people">
        <div class="label">
          平均访问人次
        </div>
        <div class="value underline">{{averageVisits||'-'}} 次</div>
        <div class="label" style='margin-top: 16px;'>
          平均关注人数
        </div>
        <div class="value fix-box-align-center">
          <div class='underline' style='margin-right: 4px;'>{{averageFavors||'-'}}</div> 人
        </div>
      </div>
    </div>
    <rateChart :list='list'/>
  </container>
</template>

<script>
  import container from "../container";
  import gauge from "./gauge";
  import rateChart from "./rateChart";
  import {platformDataStatistics} from "../../../../../api/bigData";

  export default {
    name: "operationDataStatistics",
    components: {
      container,
      gauge,
      rateChart,
    },
    data() {
      return {
        averageVisits:'0',
        averageFavors:'0',
        premiumRate:0,
        list:[],
        loading:false,
        nodata:false,
      }
    },
    methods: {
      init(){
        this.loading=true
        platformDataStatistics({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.averageVisits=data.content.averageVisits||0
            this.averageFavors=data.content.averageFavors||0
            this.premiumRate=Number(data.content.premiumRate)||0
            let list=data.content.list
            for (let i = 0; i < list.length; i++) {
              list[i].rate=Number(list[i].rate)||0
            }
            this.loading=false
            this.list=list
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
          this.nodata=!this.list.length
        })
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style scoped lang="scss">
  .operationDataStatistics {
    margin-top: 26px;
    padding-left: 14px;
    .people{
      padding-bottom: 17px;
      margin-left: 26px;
      .value{
        color: #00E69A;
        font-size: 16px;
      }
      .label{
        color: #B8D7FF;
        font-size: 14px;
      }
      .underline{
        position: relative;
        &:after{
          content: '';
          display: block;
          width: 100%;
          height: 1px;
          background: #00E69A;
          left: 0;
          bottom: -4px;
        }
      }
    }
  }
</style>
